import { RelationshipToPatientV4 } from '@tempus/patient-forms-service-shared';
import { featureEnabledInEnvironment } from '../../../../../../config/feature-toggles';

export const requiresInternalAuthentication = (relationshipToPatient: RelationshipToPatientV4): boolean => {
  return (
    featureEnabledInEnvironment('enableFaConsentFormVersion') &&
    relationshipToPatient === RelationshipToPatientV4.TEMPUS_REPRESENTATIVE
  );
};
